const resources = import.meta.glob('../resources/*.tx.json', { eager: true, import: 'default' });

export function getMessages() {
  const messages = {};
  Object.keys(resources).forEach((key) => {
    const locale = key.split(/[/.]/)[4]
    messages[locale] = resources[key]
  });
  return messages;
}

export function getLanguages() {
  const languages = [];
  Object.keys(resources).forEach((key) => {
    const locale = key.split(/[/.]/)[4]
    languages.push({
      locale,
      language: new Intl.DisplayNames([locale], { type: 'language' }).of(locale)
    })
  });
  return languages;
}